import * as React from 'react';
import { Provider } from 'react-redux';
import { Toaster } from '../shared/common/components/ui/sonner';
import RootRouter from '../shared/routes';
import { GlobalModalRoot } from '../shared/common/global-manager';
import { ThemeProvider } from '../shared/common/theme';
import { DebugMenu } from '../shared/common/components/debug-menu';
import { fetchPromotions } from '../shared/modules/core/actions/promotions';
import { UploadedSchedulesProvider } from '../shared/modules/schedules/context/uploaded-schedules-context';

const fetchInfo = async (store) => {
  try {
    const infoResponse = await fetch(process.env.INFO_URL || 'https://assets.oneteam.io/info.json', {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        Accept: 'application/json',
      },
    });
    const info = await infoResponse.json();

    store.dispatch({
      type: 'INFO',
      ...info,
    });
  } catch (err) {
    // Do nothing
  }
};

const App = ({ store }) => {
  React.useEffect(() => {
    fetchInfo(store);
    fetchPromotions(store.dispatch);
  }, [store]);

  return (
    <Provider store={store}>
      <UploadedSchedulesProvider>
        <ThemeProvider>
          <RootRouter />
          <GlobalModalRoot />
          <Toaster position="top-center" />
          {process.env.API_ENV && process.env.API_ENV !== 'production' && <DebugMenu />}
        </ThemeProvider>
      </UploadedSchedulesProvider>
    </Provider>
  );
};

export default App;
